import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { GuiaEstablecimientoEntry } from 'src/app/shared/entrys/guia-establecimiento.entry';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class CompletaInformacionServiceGuia implements RequestCRUD<RNTPrestadorEntry, ResponseServiceModel>  {
	private API_URL;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/Categoria/DisponiblesPorEstablecimiento/${entry}`).pipe(
			retry(2)
		);
	}

	getSubCategoria(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/SubCategoria/DisponiblesPorEstablecimiento`, entry).pipe(
			retry(2)
		);
	}

	sendNotificar(entry: any) {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Solicitud/AsignarFuncionario`, entry).pipe(
			retry(2)
		);
	}

	update(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/Establecimiento/${entry.establecimiento_id}`, entry).pipe(
			retry(2)
		);
	}

	getEstablecimiento(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/Establecimiento/${entry.establecimiento_id}`).pipe(
			retry(2)
		);
	}

	getEstablecimientoInscripcion(): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/Establecimiento/ObtenerDatosComerciante`).pipe(
			retry(2)
		);
	}

	create(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Rnt/Crear`, entry).pipe(
			retry(2)
		);
	}

	delete(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	createEdition(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Solicitud/CrearEdicion`, entry).pipe(
			retry(2)
		);
	}

	createActualizacion(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Solicitud/CrearActualizacion`, entry).pipe(
			retry(2)
		);
	}
	updateGuia(entry: GuiaEstablecimientoEntry): Observable<ResponseServiceModel> {
		return this.http
			.put<ResponseServiceModel>(
				`${this.API_URL}/InformacionPendienteEdicion/ActualizarPorDetalleSolicitud/${entry.detalle_solicitud_id}`, entry).pipe(
					retry(2)
				);
	}

	getEstablecimientosPendiente(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/InformacionPendienteEdicion/ObtenerPorDetalleSolicitud`, entry).pipe(
			retry(2)
		);
	}

	updateEstablecimientoPendiente(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/InformacionPendienteEdicion/ActualizarPorDetalleSolicitud/${entry.detalle_solicitud_id}`, entry).pipe(
			retry(2)
		);
	}

	// Solo debe ser para proceso de actualizacion
	cambiarCategoria(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Rnt/CambiarSubcategoria`, entry).pipe(
			retry(2)
		);
	}

	getParametro(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Parametro/DetallePorId`, entry).pipe(
			retry(2)
		);
	}
	getCategoriaById(id: number):  Observable<any> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/Categoria/${id}`).pipe(
			retry(2)
		);
	}
}
